import React from "react"
import SurveyResult from "./survey-result"
import useSectionData from "../static_queries/useSectionData"

export default function SectionList() {
  const sectionData = useSectionData()

  function renderSectionData() {
    const orderedSections = [];

    sectionData.file.childMarkdownRemark.frontmatter.sections.map(section => {
      orderedSections.push(section.slice(0, -3))
    })

    return (
      <div>
        {
          orderedSections.map((orderedSection, i) => {
            return(
              <React.Fragment key={i}>
              {sectionData.allFile.edges.map(section => {
                const thisSectionName = `content/sections/${section.node.name}`
                const firstSection = section.node.name === 'introduction'

                if (orderedSection === thisSectionName) {
                  return (
                    <section key={section.node.name} className={`is-section ${!firstSection && 'my-6 pt-6'}`} id={section.node.name}>
                      {section.node.childMarkdownRemark.frontmatter.show_title_in_content === true &&
                        <>
                          <h2 className="title is-2 mt-4">{section.node.childMarkdownRemark.frontmatter.title}</h2>
                          <p className="subtitle is-4 is-uppercase">{section.node.childMarkdownRemark.frontmatter.subtitle}</p>
                        </>
                      }
                      {section.node.childMarkdownRemark.html &&
                        <div
                          className="is-section-content content py-5"
                          dangerouslySetInnerHTML={{ __html: section.node.childMarkdownRemark.html }}
                        ></div>
                      }
                      {section.node.childMarkdownRemark.frontmatter.survey_results.map((result, i) => {
                        const resultRelativePath = result.replace('content/survey-results/','')
                        return (
                          <SurveyResult key={i + section.node.id} resultRelativePath={resultRelativePath} ></SurveyResult>
                        )
                      })}
                    </section>
                  )
                }
              })}
              </React.Fragment>
            )
          })
        }
      </div>
    )
  }
  return (
    <div>
      {renderSectionData()}
    </div>
  )
}
